/*
 * useCloseCardOnUserMove
 *
 * Purpose:
 * - Keep MainComponent lean by owning the map-interaction side effect that
 *   closes the open info card.
 *
 * Behaviour:
 * - Closes the card on a user-initiated map drag or zoom. Uses
 *   'dragstart'/'zoomstart' (not 'movestart'/'moveend') so a programmatic
 *   recenter via map.setView(center, map.getZoom()) — e.g. when clicking a
 *   vessel icon — does not close the card it just opened: the recenter keeps
 *   the zoom unchanged (no 'zoomstart') and triggers no drag.
 */

import { useEffect } from "react";

export default function useCloseCardOnUserMove({ map, closeCard }) {
  useEffect(() => {
    if (!map) return undefined;
    const handleUserMove = () => closeCard();
    map.on("dragstart", handleUserMove);
    map.on("zoomstart", handleUserMove);
    return () => {
      map.off("dragstart", handleUserMove);
      map.off("zoomstart", handleUserMove);
    };
  }, [map, closeCard]);
}
